export type LangCode = 'ru' | 'zh'

export interface LanguageDef {
  code: LangCode
  label: string
  /** Value of the `language` where-arg exposed by WPGraphQL Polylang (LanguageCodeFilterEnum). */
  graphqlCode: string
}

export const LANGUAGES: LanguageDef[] = [
  { code: 'ru', label: 'RU', graphqlCode: 'RU' },
  { code: 'zh', label: '中文', graphqlCode: 'ZH' },
]

export const DEFAULT_LANG: LangCode = 'ru'

export function isLangCode(value: string | undefined): value is LangCode {
  return value === 'ru' || value === 'zh'
}

export function graphqlLanguageCode(lang: LangCode): string {
  return LANGUAGES.find(l => l.code === lang)?.graphqlCode ?? DEFAULT_LANG.toUpperCase()
}
